const PlansSection = () => (
  <section id="avtaler" className="py-24 bg-slate-100" data-testid="plans-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">
          Avtalestruktur
        </span>
        <h2 className="font-serif-heading text-3xl sm:text-4xl font-bold text-[#0B132B] mt-2">
          Våre strømavtaler for bedrifter
        </h2>
        <p className="text-slate-600 mt-4 leading-relaxed">
          Tilpasset virksomheter med alt fra mindre kontorlokaler til
          industrielt kraftforbruk.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8 items-stretch">
        {/* Avtale 1: Forvaltning med prissikring */}
        <div
          className="p-8 rounded-2xl bg-white border-2 border-emerald-500 shadow-xl flex flex-col justify-between relative"
          data-testid="plan-card-flexsikring"
        >
          <div className="absolute -top-3.5 right-6 bg-emerald-600 text-white text-[11px] font-bold px-3 py-1 rounded-full uppercase tracking-wider">
            Mest populær B2B
          </div>
          <div>
            <span className="text-xs font-semibold text-emerald-600 uppercase tracking-wider">
              Flaggskip
            </span>
            <h3 className="text-2xl font-bold text-[#0B132B] mt-1">
              Flexsikring
            </h3>
            <p className="text-sm text-slate-600 mt-3 leading-relaxed">
              Vi planlegger og gjennomfører strømkjøp i Nasdaq og Nordpool over
              tid for å slå spotprisen og jevne ut pristoppene.
            </p>

            <div className="my-6 py-6 border-y border-slate-100 space-y-3">
              <div className="flex justify-between items-baseline">
                <span className="text-sm text-slate-600">Påslag per kWh:</span>
                <span className="text-lg font-bold text-[#0B132B]">3 øre</span>
              </div>
              <div className="flex justify-between items-baseline">
                <span className="text-sm text-slate-600">Fast månedsbeløp:</span>
                <span className="text-lg font-bold text-[#0B132B]">49 kr</span>
              </div>
              <div className="flex justify-between items-baseline">
                <span className="text-sm text-slate-600">Handelsplattform:</span>
                <span className="text-sm font-semibold text-slate-800">
                  Nasdaq &amp; Nordpool
                </span>
              </div>
            </div>

            <ul className="space-y-3 text-sm text-slate-600 mb-8">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                100% fornybar energi inkludert
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                Aktiv sikring mot høye vinterpriser
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                Ubegrenset rådgivning og rapportering
              </li>
            </ul>
          </div>

          <a
            href="#kontakt"
            className="block w-full py-3.5 px-4 rounded-lg bg-emerald-500 hover:bg-emerald-400 text-[#0B132B] font-bold text-center text-sm transition-colors"
            data-testid="plan-select-flexsikring-button"
          >
            Velg Flexsikring
          </a>
        </div>

        {/* Avtale 2: Fastpris */}
        <div
          className="p-8 rounded-2xl bg-white border border-slate-200 shadow-sm flex flex-col justify-between opacity-90"
          data-testid="plan-card-fastpris"
        >
          <div>
            <div className="inline-block bg-slate-200 text-slate-700 text-[11px] font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-2">
              Lanseres snart
            </div>
            <h3 className="text-2xl font-bold text-[#0B132B]">Fastprisavtale B2B</h3>
            <p className="text-sm text-slate-600 mt-3 leading-relaxed">
              Forutsigbarhet i budsjettene. Fast kilowattimepris gjennom hele
              avtaleperioden uansett markedssvingninger.
            </p>

            <div className="my-6 py-6 border-y border-slate-100 space-y-3 text-sm text-slate-600">
              <div className="flex justify-between">
                <span>Binding:</span>
                <span className="font-medium text-slate-800">12 eller 24 måneder</span>
              </div>
              <div className="flex justify-between">
                <span>Opprinnelsesgaranti:</span>
                <span className="font-medium text-slate-800">Inkludert</span>
              </div>
              <div className="flex justify-between">
                <span>Status:</span>
                <span className="font-semibold text-emerald-600">Åpnes for reservasjon</span>
              </div>
            </div>

            <p className="text-xs text-slate-500 leading-relaxed mb-8">
              Meld bedriftens interesse nå for å få tilbud i første pulje når
              fastpriskvotene åpnes.
            </p>
          </div>

          <a
            href="#kontakt"
            className="block w-full py-3.5 px-4 rounded-lg bg-slate-100 hover:bg-slate-200 text-[#0B132B] font-semibold text-center text-sm transition-colors"
            data-testid="plan-interest-fastpris-button"
          >
            Meld interesse for fastpris
          </a>
        </div>

        {/* Skreddersydd avtale */}
        <div
          className="p-8 rounded-2xl bg-[#0B132B] text-white flex flex-col justify-between"
          data-testid="plan-card-custom"
        >
          <div>
            <span className="text-xs font-semibold text-emerald-400 uppercase tracking-wider">
              Større forbruk (&gt;100 MWh)
            </span>
            <h3 className="text-2xl font-bold text-white mt-1">
              Skreddersydd B2B-avtale
            </h3>
            <p className="text-sm text-slate-300 mt-3 leading-relaxed">
              Har bedriften flere anlegg, produksjonslinjer eller høyt årlig
              energiforbruk? Vi setter opp en tilpasset forvaltningsstrategi.
            </p>

            <div className="my-6 py-6 border-y border-white/10 space-y-3 text-sm text-slate-300">
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
                Porteføljeforvaltning for flere målere
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
                Dedikert kraftmegler og rådgiver
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
                Samlefaktura og detaljert forbruksinnsikt
              </div>
            </div>
          </div>

          <a
            href="#kontakt"
            className="block w-full py-3.5 px-4 rounded-lg bg-emerald-500 hover:bg-emerald-400 text-[#0B132B] font-bold text-center text-sm transition-colors"
            data-testid="plan-custom-button"
          >
            Be om skreddersydd løsning
          </a>
        </div>
      </div>

      <div className="mt-12 text-center">
        <a
          href="/privat"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white border border-slate-300 hover:border-emerald-500 text-sm font-semibold text-[#0B132B] transition-colors shadow-sm"
          data-testid="plans-privat-link"
        >
          Privatkunde? Se Rstrøm Privat – 0 øre påslag og 49 kr i måneden →
        </a>
      </div>
    </div>
  </section>
);

export default PlansSection;
